import { useParams, Link } from "react-router-dom";
import HeaderOne from "../components/HeaderOne";
import Breadcrumb from "../components/Breadcrumb";
import ProductCategoryPage from "../components/ProductCategory";
import FooterOne from "../components/FooterOne";
import ColorInit from "../helper/ColorInit";
import ScrollToTop from "react-scroll-to-top";
import useFetchApiData from "../helper/useFetchApiData";

const CategoryPage = () => {
  const { id } = useParams();
  console.log("Fetched id:", id);

  // Fetch product data for the specific category
  const product_data = useFetchApiData(`/categories/products/${id}`);
  const cat_data = useFetchApiData(`/categories`);

  // Find the current category based on `id`
  function getItemById(cid) {
    if (!cat_data || cat_data.length ===0) return null;
    return cat_data.find((entry) => entry.id ===cid) || null;
  }

  const basecategory = getItemById(Number(id)) || {};

  console.warn("Product Data:", product_data);//it shows the array of objects
  console.log("Category Data:", basecategory);

  // Show 404 page if category doesn't exist or no product data
  if (Object.keys(basecategory).length===0) {
    return <NotFoundPage />;
  }

  return (
    <>
      <ColorInit color={true} />
      <ScrollToTop smooth color="#FA6400" />
      <HeaderOne category={true} />
      <Breadcrumb title={basecategory.name || "Unknown Category"} />
      <ProductCategoryPage
        key={id}
        data={product_data}
        bannerUrl={basecategory.banner_image_fullpath}
        profileImageUrl={basecategory.image_fullpath}
        categoryName={basecategory.name || "Unknown Category"}
      />
      <FooterOne />
    </>
  );
};

// NotFoundPage Component inside the same file
const NotFoundPage = () => {
  return (
    <div style={{ textAlign: "center", padding: "50px" }}>
      <h1>404 - Page Not Found</h1>
      <p>The category or products you are looking for do not exist.</p>
      <Link to="/" style={{ color: "#FA6400", fontWeight: "bold" }}>
        Go Back Home
      </Link>
    </div>
  );
};

export default CategoryPage;
